export const localStorageKeys = {
  /** храним данные стора в session при перезагрузке страницы **/
  appState: 'creditSelectionState-v1',
  platformConsentModalShown: 'platformConsentModalShown',
  esiaConsentsUpdateModalShown: 'esiaConsentsUpdateModalShown',
};
